<template>
  <!-- 农机具服务·二级页面 -->
  <div>
    <div id="num_farming" ref="farming">
      <div class="echarts_border">
        <!-- 图例 -->
        <div class="echart_zonglans">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font"></span>
          </div>
        </div>
        <div id="echart_farming_one"></div>
        <!-- 表格 -->
        <div class="echart_zonglan">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font"></span>
          </div>
        </div>
        <table
          class="table_cont"
          border="1"
          cellpadding="0"
        >
          <tr
            style="color: #1eeabe; background: #0a4960; border-color: #0a4960"
          >
            <td style="width: 100px">年份</td>
            <td>作业车辆</td>
            <td>作业面积</td>
            <td>服务企业数量</td>
          </tr>
          <tr v-for="(item, index) in tableList" :key="index">
            <td>{{ item.theYear}}</td>
            <td>{{ item.carNumber}}辆</td>
            <td>{{ item.areaNumber}}亩</td>
            <td>{{ item.companyNumber}}</td>
          </tr>
        </table>
        <div style="margin-top:15px">
           <p class="text-center">数据来源：{{ Data_txt }}、{{ Data_txtTwo }}</p>
        </div>     
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      // 图例接口数据
      oneAreaYearList: [],
      oneAreaNumberList: [],
      oneCompanyList: [],
      oneNumberList: [],
      // 表格接口数据
      tableList: [],
      // 数据来源
      Data_txt: "",
      Data_txtTwo: "",
    };
  },
  created() {},
  mounted() {
    this.init_one();
    this.init_two();
    this.Sources();
  },
  methods: {
    // 图例
    init_one() {
      var data_Zhizhong = plOtherDataInterface.getMachineEveryYear();
      var areaList = data_Zhizhong.everyYearWorkArea;
      var numberList = data_Zhizhong.everyYearCarNumber;
      var companyList = data_Zhizhong.everyYearCompanyNumber;
      this.oneAreaYearList = areaList.map((item) => item.theYear);
      this.oneAreaNumberList = areaList.map((item) => item.theNumber);
      this.oneNumberList = numberList.map((item) => item.theNumber);
      this.oneCompanyList = companyList.map((item) => item.theNumber);
      var myChart1 = echarts.init(
        document.getElementById("echart_farming_one")
      );
      var option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return `
            <div style="font-size:12px;">${params[0].seriesName}：${params[0].data}亩</div>
            <div style="font-size:12px;">${params[1].seriesName}：${params[1].data}辆</div>
            <div style="font-size:12px;">${params[2].seriesName}:${params[2].data}个</div>
            `;
          },
        },
        legend: {
          data: [
            { name: "作业面积", textStyle: { color: "#fff",fontSize:16 } },
            { name: "作业车辆", textStyle: { color: "#fff",fontSize:16 } },
            { name: "企业数量", textStyle: { color: "#fff",fontSize:16} },
          ],
        },
        yAxis: [
          {
            name: "面积/单位(亩)",
            type: "value",
            color: "#fff",
            nameTextStyle: {
              color: "#fff",
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
          {
            name: "数量/单位(个)",
            type: "value",
            color: "#fff",
            nameTextStyle: {
              color: "#fff",
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        xAxis: {
          type: "category",
          //   boundaryGap: false,
          data: this.oneAreaYearList,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",         
              fontSize:16
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: "#ccc",
              width: 1,
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "作业面积",
            data: this.oneAreaNumberList,
            type: "line",
            yAxisIndex: 0,
            smooth: false,
            itemStyle: {
              normal: {
                color: "#49F0FF",
              },
            },
          },
          {
            name: "作业车辆",
            data: this.oneNumberList,
            type: "line",
            yAxisIndex: 1,
            smooth: false,
            itemStyle: {
              normal: {
                color: "#4D7BFF",
              },
            },
          },
          {
            name: "企业数量",
            data: this.oneCompanyList,
            type: "line",
            yAxisIndex: 1,
            smooth: false,
            itemStyle: {
              normal: {
                color: "#FA7D7D",
              },
            },
          },
        ],
      };
      option && myChart1.setOption(option);
    },
    // 表格
    init_two() {
      // 调取数据    
      this.tableList = plOtherDataInterface.getMachineEveryYearTable();
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[4].farming;
      this.Data_txtTwo = dataSources.data[4].production;
    },
  },
};
</script>

<style lang="less" scoped>
#num_farming {
  background: #15606e;
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  border-top: 1px solid rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-top: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}
#echart_farming_two,
#echart_farming_one {
  height: 18.75rem;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

// 表格样式
.table {
  background: #0a4960;
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
}
.table_cont {
  width: 100%;
  border-collapse: collapse;
  color: #fff;
  font-size: 16px;
  border-color: #83aabe;
  td {
    padding: 10px 0;
  }
}
.table_cont tr {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/details/detail_tool.vue